
import { db } from './firebaseConfig';
import { doc, updateDoc } from "firebase/firestore";

const ActualizarFamiliaDb = async  ({id, familia, /*activo,*/ userMod, fechaMod}) => {

    return await updateDoc(doc(db, 'familias', id),{
        familia: familia,
        // activo: activo,
        usermod: userMod,
        fechamod: fechaMod
    })
}

export default ActualizarFamiliaDb;